"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createHtmlFromLink = void 0;
var createHtmlFromLink = function (token) {
    throw new Error("Not implemented");
};
exports.createHtmlFromLink = createHtmlFromLink;
